import api from "../../../helpers/api";


// export const getArtisans = (body) => api.post('supplier/search-suppliers', {...body})

// export const getArtisan = (id) => api.get(`supplier/${id}`)

// export const createArtisan = (formData) => api.post('supplier' , {...formData})
// // export const createArtisan = (formData) => api.post('supplier-staging' , {...formData})

// export const updateArtisan = (id , formData) => api.put(`supplier/${id}` , {...formData})

// // export const updateArtisan = (id , formData) => api.put(`/supplier-staging/` , {id,...formData})

// export const deleteArtisan = (id) => api.delete(`supplier/${id}`)


// export const addFollower = (supplierId, userId) => api.post('supplier/add-follower', {supplierId, userId})
// export const removeFollower = (supplierId, userId) => api.post('supplier/rem-follower', {supplierId, userId})
export const getFollowers = (supplierId) => api.post('supplier/get-followers', supplierId) 

export const getFollowersCount = (supplierId) => api.post('supplier/get-followers-count/', supplierId)

// export const addEditorsReview = (supplierId,formData) => api.post('supplier/editor-rating' , {supplierId,...formData})